document.querySelectorAll('a.link-button.event-checkout').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        const url = this.href;
        fbq('track', 'InitiateCheckout');
        window.location.href = url;
    });
});
